import { render, staticRenderFns } from "./FriendMemo.vue?vue&type=template&id=1bc0b758&scoped=true&"
import script from "./FriendMemo.vue?vue&type=script&lang=js&"
export * from "./FriendMemo.vue?vue&type=script&lang=js&"
import style0 from "./FriendMemo.vue?vue&type=style&index=0&id=1bc0b758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc0b758",
  null
  
)

export default component.exports